// extracted by mini-css-extract-plugin
export default {"root":"dIGpP","stats":"_1QTUY","boosted":"B8GRA","boosted-text":"tZMOZ","boostedText":"tZMOZ"};